import { Grid2 } from "@mui/material";
import { NavBar } from "../AdminComponents/Navbar";

import styles from "./OrganizationOverviewAdmin.module.scss";
import { useState } from "react";

export default function OrganizationOverviewAdmin({
  component: PageComponent,
  ...rest
}) {
  const [search, setSearch] = useState(false);
  const [value, setValue] = useState("");
  return (
    <>
      <Grid2 className={styles.containerBackground}>
        <Grid2 className={styles.Background}>
          <NavBar
            search={search}
            setSearch={setSearch}
            value={value}
            setValue={setValue}
          />
          <PageComponent searchValue={value} setSearch={setSearch} />
        </Grid2>
      </Grid2>
    </>
  );
}
